import React from "react";
import { labels } from "../i18n/translations";
import WhatsAppButton from "../components/WhatsAppButton";
import { WHATSAPP_NUMBER } from "../lib/whatsapp";

const Info = ({ label, value, testId }) => (
  <div data-testid={testId} className="py-6 border-b border-black/10">
    <div className="uppercase tracking-[0.22em] text-[10px] text-black/45 mb-2">
      {label}
    </div>
    <div className="font-heading text-xl md:text-2xl tracking-tight">{value}</div>
  </div>
);

export const Contact = () => (
  <main data-testid="page-contact" className="pt-12 md:pt-20">
    <section className="px-6 md:px-12 lg:px-20 pb-24 md:pb-32 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
      <div className="lg:col-span-7">
        <div className="uppercase tracking-[0.32em] text-[11px] text-[#C5A059] mb-5">
          {labels.contact.overline}
        </div>
        <h1
          data-testid="contact-title"
          className="font-heading text-5xl md:text-6xl lg:text-7xl font-light tracking-tighter leading-[0.95]"
        >
          {labels.contact.title}
        </h1>
        <p className="mt-8 text-base md:text-lg text-black/65 font-light leading-relaxed max-w-xl">
          {labels.contact.text}
        </p>

        <div className="mt-12">
          <WhatsAppButton
            testId="contact-whatsapp-cta"
            message={labels.contact.whatsapp_msg}
            size="lg"
            variant="gold"
          >
            {labels.contact.whatsapp_cta}
          </WhatsAppButton>
        </div>
      </div>

      <aside className="lg:col-span-5 lg:pl-10 lg:border-l lg:border-black/10">
        <Info label={labels.contact.number_label} value={WHATSAPP_NUMBER} testId="contact-info-phone" />
        <Info label={labels.contact.hours_label} value={labels.contact.hours_value} testId="contact-info-hours" />
        <Info label={labels.contact.response_label} value={labels.contact.response_value} testId="contact-info-response" />
      </aside>
    </section>
  </main>
);

export default Contact;
